import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { LivescanResponseAttachmentsVO, LivescanResponseAttachmentsRes, DownloadFileVO } from '../../models/application';

@Injectable()
export class LivescanResponseAttachmentsService {
    public livescanResponseAttachmentsVOList: LivescanResponseAttachmentsVO[];
    public livescanResponseAttachmentsVO: LivescanResponseAttachmentsVO;
    public filesToUpload: Array<File>;
    filenames: string[];
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('LivescanResponseAttachmentsService');
    }
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    liveScanInfoInit(){
        this.livescanResponseAttachmentsVOList=[];
  this.livescanResponseAttachmentsVO= new LivescanResponseAttachmentsVO();
    }
    saveLivescanResponseAttachments(livescanResponseId: number, filesToUploadParam: Array<File>,
        userName: string): Observable<any> {
        const formData: FormData = new FormData();

        for (let i: number = 0; i < filesToUploadParam.length; i++) {
            const file: File = filesToUploadParam[i];
            formData.append(`files`, file, file.name);

        }
        let options = {
            headers: new HttpHeaders({
                'enctype': 'multipart/form-data',

                "Cache-Control": "no-cache",
                Pragma: "no-cache"
            })
        };

        return this._http.post<LivescanResponseAttachmentsRes>(
            environment.saveLivescanResponseAttachmentsUrl + "?livescanResponseId=" + livescanResponseId + "&userName="
            + userName, formData, options)
            .pipe(
                catchError(this.handleError('saveLivescanResponseAttachments', []))
            );
    }
    downloadFiles(id: number,userName:string): Observable<DownloadFileVO[]> {
        return this._http.get<DownloadFileVO[]>(
            environment.getdownloadAttachFilesUrl + id+"?userName="+userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('downloadFiles', []))
            );
    }
    deleteLivescanResponseAttachmentById(id: number, userName: string): Observable<any> {
        return this._http.get<LivescanResponseAttachmentsVO[]>(environment.deleteLivescanResponseAttachmentByIdUrl + id +"?userName=" + userName, this.httpOptions)
            .pipe(catchError(this.handleError('deleteLivescanResponseAttachmentById', [])));
    } 
}